// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__3BycU","icon":"SortAdornment_icon__InwFJ","up":"SortAdornment_up__15uYT","down":"SortAdornment_down__3ZIrx","active":"SortAdornment_active__2-JQ8"};